import styled from 'styled-components';
import { Link } from 'gatsby';

import { COLOR_FONT_0, COLOR_FONT_1, COLOR_LINK_0, COLOR_SURFACE_1, COLOR_SURFACE_1_RELIEF } from '../colors';

/**
 *
 */
export const Paper = styled.div`
  overflow: hidden;
  align-self: start;
  margin: 8px 0 0 8px;
  background: ${COLOR_SURFACE_1};
  border-radius: 4px;

  @media all and (min-width: 768px) {
    margin: 16px 0 0 16px;
  }

  @media all and (min-width: 1440px) {
    margin: 24px 0 0 24px;
  }
`;

/**
 *
 */
export const PaperTitle = styled.h3`
  padding: 8px;
  border-bottom: 1px solid ${COLOR_SURFACE_1_RELIEF};
  line-height: 32px;
  font-size: 18px;
  font-weight: 400;
  color: ${COLOR_FONT_1};

  a,
  a:visited {
    color: ${COLOR_FONT_1};

    &:hover {
      color: ${COLOR_FONT_0};
    }
  }

  @media all and (min-width: 768px) {
    padding: 8px 16px;
  }
`;

/**
 *
 */
export const PaperPadding = styled.div`
  overflow: hidden;
  padding: 8px;

  @media all and (min-width: 768px) {
    padding: 16px;
  }

  @media all and (min-width: 1440px) {
    padding: 24px;
  }
`;

/**
 *
 */
export const PaperText = styled.div`
  padding: 8px;
  text-align: justify;

  a {
    color: ${COLOR_FONT_0};

    &:visited {
      color: ${COLOR_FONT_0};
    }

    &:hover {
      color: ${COLOR_LINK_0};
    }
  }

  @media all and (min-width: 768px) {
    padding: 16px;
  }

  @media all and (min-width: 1440px) {
    padding: 24px;
  }
`;

/**
 *
 */
export const PaperLink = styled(Link)`
  display: block;
  border-top: 1px solid rgba(255, 255, 255, 0.03);
  line-height: 48px;
  text-align: center;
  text-transform: uppercase;
  font-size: 12px;
  font-weight: 400;
  color: ${COLOR_FONT_1};

  &:visited {
    color: ${COLOR_FONT_1};
  }

  &:hover {
    color: ${COLOR_LINK_0};
  }
`;
